import React from 'react';
import { useAppDispatch, useAppSelector} from "../DAL/store";

import {SearchAction} from "../services/logic-helper";

export interface IPaginationProps {
    setIsLoading: any;
}
const Pagination = (props : IPaginationProps) => {
    const dispatch = useAppDispatch();
    const CurrentPageNumber = useAppSelector((store) => store.CurrentPageNumber);
    const CurrentMainTab = useAppSelector((store) => store.CurrentMainTab);
    const NumberOfItemsPerPage = useAppSelector((store) => store.NumberOfItemsPerPage);
    const TotalNumberOfResults = useAppSelector((store) => store.TotalNumberOfResults);
    const SearchQuery = useAppSelector((store) => store.SearchQuery);

    const totalPagesNumber = Math.ceil(TotalNumberOfResults / NumberOfItemsPerPage);

    const backIsNotAllowed = CurrentPageNumber === 0;
    const nextIsNotAllowed = CurrentPageNumber + 1 === totalPagesNumber;

    const applyPagination = async (isPrevious : boolean) => {
        let searchPageNumber = isPrevious ? CurrentPageNumber - 1 : CurrentPageNumber + 1;

        if(searchPageNumber < 0 || searchPageNumber >= totalPagesNumber){
            return;
        }

        await SearchAction(SearchQuery,CurrentMainTab,searchPageNumber,dispatch,false,props.setIsLoading);
        // jump to top
        window.scrollTo(0, 0);
    }

    return (
        <div className="flex items-center w-full lg:w-3/4 xl:w-2/3 mt-6">
            <button
                type="button"
                className={`mr-1 ${backIsNotAllowed ? " disabled cursor-not-allowed" : " cursor-pointer"}`}
                onClick={async evt => {
                    await applyPagination(true);
                }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"><title>Previous Page Button</title><g fill="none" fillRule="evenodd"><rect width="29" height="29" x=".5" y=".5" fill="#D8D8D8" fillRule="nonzero" stroke="#979797" opacity=".123" rx="14.5"/><path d="M17.295 9.705c.39.39.39 1.02 0 1.41L13.42 15l3.876 3.884a.999.999 0 0 1-1.411 1.411L10.59 15l5.295-5.295a.996.996 0 0 1 1.41 0z" fill="#252525"/></g></svg>
            </button>

            <button
                type="button"
                className={`ml-1 ${nextIsNotAllowed ? " disabled cursor-not-allowed" : " cursor-pointer"}`}
                onClick={async evt  => {
                    await applyPagination(false);
                }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"><title>Next Page Button</title><g fill="none" fillRule="evenodd"><rect width="29" height="29" x=".5" y=".5" fill="#D8D8D8" fillRule="nonzero" stroke="#979797" opacity=".123" rx="14.5"/><path d="M12.705 9.705a.996.996 0 0 0 0 1.41L16.58 15l-3.876 3.884a.999.999 0 0 0 1.411 1.411L19.41 15l-5.295-5.295a.996.996 0 0 0-1.41 0z" fill="#252525"/></g></svg>
            </button>

            <span className="mx-4">
                Page { CurrentPageNumber + 1} of { totalPagesNumber }
            </span>
        </div>


    )
};

export default Pagination;